import { render, staticRenderFns } from "./ServiceHero.vue?vue&type=template&id=754a0a98&scoped=true"
import script from "./ServiceHero.vue?vue&type=script&lang=js"
export * from "./ServiceHero.vue?vue&type=script&lang=js"
import style0 from "./ServiceHero.vue?vue&type=style&index=0&id=754a0a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a0a98",
  null
  
)

export default component.exports